import { createViewContext } from "../../../Components/createViewContext"
import type { IShip, IShipUser } from "../../../Types"

export interface AllShipsData {
  ships?: IShip[];
  membership?: IShipUser[];
  ownShipId?: number;
  load: (force?: boolean) => Promise<void>;
}

const allShipsContext = createViewContext<AllShipsData>();

export const AllShipsContext = allShipsContext.Context;
export const useAllShips = allShipsContext.useGet;
